  function bidIdResolver(BXDataService, $transition$) {
    return $transition$.params().bidId;
  }
  function bidResolver(BXDataService, BXReferenceService, $transition$) {
  

    let bidId = $transition$.params().bidId;

    BXDataService.getRules();
    BXDataService.getFilesRules();
  
    BXReferenceService.loadReference('bid');


  
  
    let bid = $transition$.params().bid;
    
    if(!bid){
        bid = BXDataService.getBid(bidId);
    }


  //  console.log('bidResolver',  $transition$.params());
    
    
    return bid;
  }
  function selectedServicesResolver($transition$) {
    return $transition$.params().services;
  }
  function typeResolver($transition$) {
    return $transition$.params().type;
  }
  function categoryResolver($transition$) {
    return $transition$.params().category;
  }


  
   function bidNewResolver(BXDataService) {
        return BXDataService.getBid('new');
   }
  


  function docsResolver(BXDataService, $transition$) {
  
    let bidId = $transition$.params().bidId;
  
    return BXDataService.getClaimTU(bidId);
  
  }
  
  function dataResolver(BXDataService, $transition$){
    let bidId = $transition$.params().bidId;
    return BXDataService.getProjectDocs(bidId);
  }
  
  function bidDocsResolver(BXDataService, $transition$) {
    let bidId = $transition$.params().bidId;
    return BXDataService.getBidDocs(bidId);
  }
  


  

  bidIdResolver.$inject=['BXDataService', '$transition$'];
  bidResolver.$inject=['BXDataService', 'BXReferenceService', '$transition$'];
  selectedServicesResolver.$inject=['$transition$'];
  typeResolver.$inject=['$transition$'];
  categoryResolver.$inject=['$transition$'];
  bidNewResolver.$inject = ['BXDataService']
  dataResolver.$inject = [ 'BXDataService', '$transition$'];
  docsResolver.$inject = ['BXDataService', '$transition$']
  bidDocsResolver.$inject = ['BXDataService', '$transition$']


  export {
    bidIdResolver,
    bidResolver,
    selectedServicesResolver,
    typeResolver,
    categoryResolver,
    bidNewResolver,
    dataResolver,
    docsResolver,
    bidDocsResolver
  }


// WEBPACK FOOTER //
// ./src/core/resolvers.js